<template>
  <div class="container">
    <div v-if="showMessage" class="text-center">
      <div>
        <img class="sendend-item" src="../../../public/img/flags/enviado.png">
      </div>
      <div>
        <h3 class="title-modal-success">¡Gracias por tu tiempo!</h3>
      </div>
      <div>
        <p class="text-modal-success">Nos comunicaremos contigo lo antes posible</p>
      </div>
    </div>
    <div v-if="!showMessage" class="justify-content-center form-container">
      <div class="label-title row">
        <label>E-mail:</label>
      </div>
      <div class="row">
        <input id="email" class="input-item" type="text" v-model="email" required>
      </div>
      <div class="label-title row">
        <label>Nombre:</label>
      </div>
      <div class="row">
        <input id="name" class="input-item" type="text" v-model="name" required>
      </div>
      <div class="label-title row">
        <label>Telefono:</label>
      </div>
      <div class="row">
        <input id="phone" class="input-item" type="text" v-model="phone" required>
      </div>
      <div class="label-title row">
        <label>Comentarios:</label>
      </div>
      <div class="row">
        <textarea id="comments" v-model="comments" class="comments"  required></textarea>
      </div>
      <div class="row">
        <vue-recaptcha class="captchatNew" ref="recaptcha" @verify="markRecaptchaAsVerified" sitekey="6LdlXLwUAAAAAHouUjujMEM-7Ec4_Gz0RkDmS5Xv" :loadRecaptchaScript="true"></vue-recaptcha>
      </div>
      <div class="text-center">
        <div class="error-item">{{error}}</div>
      </div>
      <div v-if="!showBotton" class="row">
        <button class="save-button btn-round check-in-button btn-style" @click="contractButton()">Enviar</button>
      </div>
      <div v-if="showBotton" class="row">
        <button class=" btn-round check-in-button btn-style">
          <img class="loader-gif" src="../../../public/img/Rolling.gif">
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import VueRecaptcha from 'vue-recaptcha';
import LoginService from '../../service/core/login.service';

export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      loginService: new LoginService(),
      email:'',
      name:'',
      phone:'',
      comments:'',
      error:'',
      showBotton: false,
      showMessage: false,
      captchatMarck: false
    }
  },
  methods:{
    markRecaptchaAsVerified(response) {
      this.pleaseTickRecaptchaMessage = '';
      this.captchatMarck = true;
    },
    contractButton(){
      this.showBotton = true
      if(this.email == ''){
        this.showBotton = false
        document.getElementById("email").classList.add("error-input")
        this.error = 'Por Favor, llene los campos marcados'
      }else{
        document.getElementById("email").classList.remove("error-input")
        this.error = ''
      }
      if(this.name == ''){
        this.showBotton = false
        document.getElementById("name").classList.add("error-input")
        this.error = 'Por Favor, llene los campos marcados'
      }else{
        document.getElementById("name").classList.remove("error-input")
        this.error = ''
      }
      if(this.phone == ''){
        this.showBotton = false
        document.getElementById("phone").classList.add("error-input")
        this.error = 'Por Favor, llene los campos marcados'
      }else{
        document.getElementById("phone").classList.remove("error-input")
        this.error = ''
      }
      if(this.comments == ''){
        this.showBotton = false
        document.getElementById("comments").classList.add("error-input")
        this.error = 'Por Favor, llene los campos marcados'
      }else{
        document.getElementById("comments").classList.remove("error-input")
        this.error = ''
      }
      if(this.captchatMarck == false){
        this.showBotton = false
        this.error = 'Marcar Captcha';
      }else{
        let conditions = {
          "contact":{
            "name": this.name,
            "phone": this.phone,
            "email": this.email,
            "comments": this.comments
          }
        }
        
        this.loginService.contact(conditions).then(data => {
          this.showMessage = true
          this.showBotton = false
        }, err =>{
          this.showBotton = false
          this.error = '¡Ups! Algo salio mal, intentalo de nuevo'
        })
      }
    }
  }
};
</script>
<style lang="scss">
.label-title{
  color: rgb(172, 172, 172);
  font-size: 13px;
  padding: 0px;
}

.input-item{
  font-size: 15px;
  width: 100%;
  margin-top: -10px;
  padding: 0px;
  margin-bottom: 10px;
  border: 1px;
  border-bottom: 2px solid rgba(167, 167, 167, 0.507);
}
.check-box{
  margin-right: 10px;
}

.check-box-text{
  color: #00bbff
}
.form-container{
  padding: 10px;
}

.btn-style{
  margin-top:20px;  
}

.error-item{
  color:red;
}

.error-input{
  -webkit-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
  -moz-box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
  box-shadow: 0px 3px 2px -1px rgba(252,8,8,0.5);
}
.comments{
  width: 100%;
  padding: 5px;
  font-size: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 2px solid rgba(167, 167, 167, 0.507);
}
.sendend-item{
  width: 100px;
}
.save-button{
  background-color: #6b8140;
  color: #ffffff;
  font-weight: bold;
}
</style>
